import { Classes, Dialog, H3 } from "@blueprintjs/core";
import classNames from "classnames";
import { JitsiUtil } from "lib/lib-jitsi-meet";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import React from "react";
import { getDynamicItem, persistSetting } from "../../common";
import styles from "./WelcomeDialog.module.css";

const hasOpenedLSKey = "hasWelcomeDialogOpened";

export interface WelcomeDialogProps {
    util: JitsiUtil;
}

@observer
export default class WelcomeDialog extends React.PureComponent<WelcomeDialogProps> {
    @observable public isOpen = false;
    @observable public isChrome = false;

    @action
    public componentDidMount() {
        this.isChrome = this.props.util.browser.isChrome();

        const hasOpened = getDynamicItem(hasOpenedLSKey);
        if (!hasOpened || !this.isChrome) {
            // open if this is a new user, or they are trying a browser which is not Chrome
            this.isOpen = true;
        }
    }

    public render() {
        return (
            <Dialog
                className={classNames(Classes.DARK, styles.container)}
                isOpen={this.isOpen}
                onClose={this.handleClose}
                title="welcome to digital dance hall 👋"
            >
                <div className={Classes.DIALOG_BODY}>
                    {!this.isChrome && (
                        <H3>
                            Important: this website works best in Google Chrome. Please{" "}
                            <a href="https://www.google.com/chrome/" target="_blank">
                                download Chrome
                            </a>{" "}
                            if necessary and re-join the party!
                        </H3>
                    )}
                    <p>
                        We're glad to have you! Grab a drink, put on a look, hang out a while, listen to the live
                        stream, and dance with friends &amp; strangers 🥳
                    </p>
                    <p>Pro tips for this internet dance party 💃</p>
                    <ul>
                        <TechnicalTips />
                    </ul>
                </div>
            </Dialog>
        );
    }

    @action
    private handleClose = () => {
        this.isOpen = false;
        persistSetting(hasOpenedLSKey as any, true);
    };
}

export function TechnicalTips() {
    return (
        <>
            <li>
                Everyone's audio is muted. On the dance floor, we're listening to the DJ stream. Use the public and
                private chat rooms to interact with people.
            </li>
            <li>
                Download{" "}
                <a href="https://snapcamera.snapchat.com/" target="_blank">
                    Snap Camera
                </a>{" "}
                for AR effects (🤡 virtual costumes!) on your webcam video. This may need a browser restart after
                installing for the first time.
            </li>
            <li>
                Each video tile is draggable - try rearranging the dance hall so you can see different people! To focus
                on specific people, pin their video to the top of the dance hall using the dropdown at the top right of
                their tile. Remember to scroll down for more videos if the dance floor fills up!
            </li>
            <li>
                You can request a private chat with each individual participant. Look for the dropdown in the top right
                of their video tile.
            </li>
        </>
    );
}
